<template>
  <div id="floor"
       @contextmenu.stop.prevent="$emit('emit',$event,arr.sign,arr.appfunIdType)"
       @touchstart.stop="touchstarts($event,arr.sign,arr.appfunIdType)"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <!-- 自适应组件 -->
    <div class="testDiv">
      <ul class="titles clearfix">
        <topButton v-if="Name.length"
                   @changeBut='changeBut'
                   :content="Name"></topButton>
        <detail-menu :index="arr.sign"
                     @emitBack='update()' />
      </ul>
      <template>
        <div class="conten">
          <div class="testCon"
               v-show="now=='0'"
               v-for="(item,ind) in arr.arrList"
               :key="ind"
               :style="{width:JSON.parse(item.attrbute).width,height:JSON.parse(item.attrbute).height,top:JSON.parse(item.attrbute).top,left:JSON.parse(item.attrbute).left}">
            <component :is="item.dataId"
                       :sortTag="item.sortTag"
                       :ind="index"
                       @sendType="sendType"
                       @sendImageText="sendImageText"
                       :imageText="imageText"
                       :type="type"
                       @emitContextMenuItem="emitParent"
                       :floor="arr.sign"></component>
          </div>
          <smartAppSameScreenShow v-if="now!='0'&&now!=Name.length-1"
                                  :number='signs'
                                  :floor="arr.sign"
                                  :blockData="blockData"></smartAppSameScreenShow>
          <pingjia v-show="now==Name.length-1"></pingjia>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import test from "./test.vue";
import topButton from "../components/floorBlock/topChangeButton.vue";
import detailMenu from "../components/floorBlock/control/detailMenu.vue";
import swipers from "../components/flowDetail/onlyswipers.vue";
import txtContent from "../components/flowDetail/txtContent.vue";
import contentShow from "../components/flowDetail/contentShow.vue";
import jinrizixun from "../components/flowDetail/jinrizixun.vue";
import jinriShow from "../components/flowDetail/jinriShow.vue";
import liveShow from "../components/flowDetail/liveShow.vue";
import pingjia from "../components/floorBlock/xiangguanpingjia.vue"
import smartAppSameScreenShow from "../components/floorBlock/detailShow.vue";
export default {
  name: "floor",
  props: {
    arr: Object,
    index: String,
    redirectUrl: String,
    blockData: Object,
    num: String
  },
  components: {
    test,
    topButton,
    detailMenu,
    swipers,
    txtContent,
    contentShow,
    jinrizixun,
    jinriShow,
    liveShow,
    pingjia,
    smartAppSameScreenShow
  },
  data () {
    return {
      timeOutEvent: 0,
      now: 0,
      rMenuPos: {
        left: 0,
        top: 0
      },
      rightShow: false,
      type: {},
      imageText: [],
      Name: [],
      number: '',
      signs: ''
    }
  },
  mounted () {
    var _this = this;
    window.addEventListener('click', () => {
      _this.rightShow = false;
    })
    _this.getShowName();
  },
  methods: {
    touchstarts (ev, type, floor) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emit', ev, type, floor);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //寻找参数
    getQuery (name) {
      // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);//substr() 的参数指定的是子串的开始位置和长度
      if (r != null) {
        // 对参数值进行解码
        return decodeURI(r[2]);
      }
      return null;
    },
    //获取上端展示名称
    getShowName () {
      var _this = this;
      _this.$http.get("zciid-deliverable/showPlatformStyle/flow/api/detail/getDetailByBlockId.json", {
        appId: _this.$appId,
        blockId: _this.getQuery('blockId'),
        sign: _this.arr.sign
      }).then(res => {
        var data = res.data ? res.data : [];
        _this.Name = data;
        _this.Name.unshift({ detailName: _this.arr.signName });
        _this.Name.push({ detailName: '商品评价' });
      })
    },
    //筛选楼层上端数据
    screening (arr, name) {
      var name1 = '相关推荐', name2 = '商品评价';
      arr.forEach((item) => {
        if (item.detailSign && item.detailSign == 'xgtj') {
          name1 = item.detailName;
        } else if (item.detailSign && item.detailSign == 'sppj') {
          name2 = item.detailName;
        }
      })
      name.push({ 'name1': name1, 'name2': name2 });
      return name;
    },
    //改变按钮
    changeBut (ind, sign) {
      this.now = ind;
      this.signs = sign;
      this.$emit('changeSign', sign);
    },
    //点击返回更新数据
    update () {
      this.$emit('emitp', this.index)
    },
    //子级组件触发父级组件
    emitParent (val, num, item) {
      this.$emit('emit', val, num, item);
    },
    //接收兄弟组件传值
    sendImageText (val) {
      this.imageText = val;
    },
    sendType (val) {
      this.type = val;
    }
  }
}
</script>
<style scoped>
#floor {
  width: 1200px;
  height: 529px;
}
#floor .titles {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #0c78cf;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
}
.testDiv {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.conten {
  position: relative;
  width: 100%;
  height: calc(100% - 39px);
  height: -moz-calc(100% - 39px);
  height: -webkit-calc(100% - 39px);
  height: -o-calc(100% - 39px);
  height: -ms-calc(100% - 39px);
}
.testCon {
  position: absolute;
  /* border: 1px solid #555; */
  overflow: auto;
  background: #fff;
}
.test .titles {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #0c78cf;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/template/Floor.vue